import http from '@/plugin/axios'

export function getAllSendSupplier(classifyNo: string) {
  return http({
    url: '/srmData/getAllSendSupplier',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: { classifyNo }
  })
}

export function getSendRecordPage(params: any) {
  return http({
    url: '/srmDataSendRecord/getSendRecordPage',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: params
  })
}

export function getActionRecordPage(params: any) {
  return http({
    url: '/srmDataActionRecord/getActionRecordPage',
    baseURL: process.env.VUE_APP_BASE_DATA_API,
    data: params
  })
}
